import styled from 'styled-components'
import Icon from './Icon'

const DeleteIcon = styled(Icon).attrs({
  type: 'circle-x',
})``

export default DeleteIcon
